import images from "./images";

const portfolio = [
    {
        id: 1,
        image: images.portfolio1,
        title: "Beach Wedding",
        details: {
            date: "June 20, 2024",
            client: "Emily & Jake",
            category: "Event Planning",
            duration: "6 Months",
            location: "Coastal Regions",
            cost: "Customized Pricing Based on Requirements",
            leadPlanner: "Sarah Beachwood"
        },
        paragraphs: [
            "Explore how our beach wedding planning services created unforgettable seaside celebrations, combining elegance with the beauty of nature.",
            "Our beach wedding planning services offer a comprehensive approach, ensuring every detail is perfect—from venue selection to floral arrangements and catering. We specialize in creating magical moments that reflect the couple's unique love story."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6
        ],
        services: [
            "Venue Selection and Setup",
            "Floral Design and Decor",
            "Catering Coordination",
            "Entertainment and Music",
            "Photography and Videography"
        ],
        highlights: [
            "Stunning Ocean Views",
            "Customized Decor",
            "Intimate Ceremony Setup"
        ],
        themes: [
            "Beach Boho Theme",
            "Elegant Floral Arrangements",
            "Romantic Lighting"
        ]
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Banquet Halls",
        details: {
            date: "March 10, 2024",
            client: "Sophia & Liam",
            category: "Venue Selection",
            duration: "3 Months",
            location: "Downtown District",
            cost: "Tailored Based on Venue and Decor",
            leadPlanner: "Olivia Hallmark"
        },
        paragraphs: [
            "Our banquet hall venue selection services ensure couples find the perfect setting for their special day—combining elegance, convenience, and personalized touches.",
            "From classic ballrooms to modern luxury halls, we help you navigate the best venue choices, manage logistics, and tailor the ambiance to suit your wedding theme and guest experience."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6
        ],
        services: [
            "Venue Research and Booking",
            "Custom Decor Planning",
            "On-Site Coordination",
            "Lighting and Ambience Setup",
            "Vendor Liaison Services"
        ],
        highlights: [
            "Luxurious Indoor Setting",
            "Ample Guest Seating",
            "Elegant Interior Themes"
        ],
        themes: [
            "Classic Ballroom Style",
            "Chic Urban Aesthetic",
            "Cultural and Traditional Decor Options"
        ]
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Garden Ceremony",
        details: {
            date: "April 22, 2024",
            client: "Ava & Noah",
            category: "Event Planning",
            duration: "4 Months",
            location: "Rosewood Botanical Gardens",
            cost: "Custom Packages Available",
            leadPlanner: "Lily Greenwood"
        },
        paragraphs: [
            "Our garden ceremony planning services transform natural landscapes into enchanting event spaces. From floral pathways to romantic altars, every element is curated to create a serene and magical wedding atmosphere.",
            "We specialize in outdoor events that capture the beauty of nature while ensuring seamless logistics, elegant styling, and a heartfelt experience for you and your guests."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6
        ],
        services: [
            "Full-Service Event Planning",
            "Garden Venue Setup",
            "Customized Floral Installations",
            "Ceremony Seating Arrangements",
            "Guest Coordination and Assistance"
        ],
        highlights: [
            "Romantic Outdoor Setting",
            "Seasonal Blooms and Greenery",
            "Personalized Ceremony Design"
        ],
        themes: [
            "Rustic Garden Charm",
            "Whimsical Nature-Inspired Decor",
            "Timeless Romantic Touches"
        ]
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "Bridal Bouquets",
        details: {
            date: "May 12, 2024",
            client: "Sophia & Liam",
            category: "Floral Design",
            duration: "2 Weeks",
            location: "Downtown Floral Studio",
            cost: "Tailored Based on Style & Flowers",
            leadPlanner: "Chloe Bloom"
        },
        paragraphs: [
            "Our bridal bouquet services are crafted with artistic elegance and personalized touches to reflect every bride’s unique style. Each bouquet is carefully designed with seasonal blooms, color harmony, and delicate details that enhance the wedding aesthetic.",
            "From classic rose arrangements to boho-chic wildflowers, we bring your floral vision to life with care, creativity, and expert craftsmanship."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6
        ],
        services: [
            "Custom Bouquet Design",
            "Flower Selection Consultation",
            "Color Palette Coordination",
            "Fresh Flower Sourcing",
            "On-Time Delivery"
        ],
        highlights: [
            "Personalized Floral Themes",
            "Fresh & Seasonal Blooms",
            "Elegant Hand-Tied Styles"
        ],
        themes: [
            "Romantic Rose Blends",
            "Boho Wildflower Bouquets",
            "Modern Minimalist Blooms"
        ]
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Outdoor Garden",
        details: {
            date: "April 28, 2024",
            client: "Olivia & Ethan",
            category: "Venue Selection",
            duration: "3 Months",
            location: "Green Haven Garden Estate",
            cost: "Custom Pricing Based on Event Scope",
            leadPlanner: "Lily Meadows"
        },
        paragraphs: [
            "Our outdoor garden venue offers a serene and picturesque setting ideal for weddings, receptions, and special events. Surrounded by lush greenery and blooming flowers, it provides the perfect backdrop for unforgettable celebrations.",
            "From layout design to on-site coordination, our team ensures that every aspect of the venue is perfectly tailored to the couple’s vision, offering both beauty and functionality in an open-air environment."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6
        ],
        services: [
            "Venue Booking & Coordination",
            "Garden Layout Planning",
            "Outdoor Seating Arrangements",
            "Lighting & Ambiance Setup",
            "Vendor Liaison for On-Site Needs"
        ],
        highlights: [
            "Naturally Beautiful Scenery",
            "Flexible Setup for Ceremonies & Receptions",
            "Ideal for Daytime and Twilight Events"
        ],
        themes: [
            "Rustic Garden Style",
            "Romantic Outdoor Elegance",
            "Eco-Friendly Celebrations"
        ]
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Table Centerpieces",
        details: {
            date: "May 10, 2024",
            client: "Sophia & Daniel",
            category: "Floral Design",
            duration: "2 Weeks",
            location: "Crystal Banquet Hall",
            cost: "Tailored Pricing Based on Arrangement Type",
            leadPlanner: "Ava Bloom"
        },
        paragraphs: [
            "Our custom-designed table centerpieces added a touch of floral elegance to the celebration. Each arrangement was thoughtfully crafted to reflect the couple's style while complementing the overall wedding theme.",
            "From minimalist chic to luxurious floral displays, we ensured that each table became a visual focal point, enhancing the ambiance and guest experience through color, fragrance, and design."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6
        ],
        services: [
            "Floral Concept Planning",
            "Custom Centerpiece Arrangement",
            "Thematic Flower Selection",
            "Table Styling & Coordination",
            "Delivery and Setup"
        ],
        highlights: [
            "Coordinated with Wedding Colors",
            "Fresh, Seasonal Blooms",
            "Elegant & Eye-Catching Designs"
        ],
        themes: [
            "Romantic Florals",
            "Modern Minimalist",
            "Classic Elegance"
        ]
    }
];

export default portfolio;